// @ts-strict-ignore
import type { Module } from 'vuex'
import type { ToolingState } from '../../models'
import type { StorageService } from '../../services/interfaces'
import { CONTAINER } from '../../config/inversify.config'
import { TYPES } from '../../config/inversify.types'
import { ResetAction } from '../common/actions/reset.action'
import { COMMON_CONSTS } from '../common/common.consts'
import { ResetMutation } from '../common/mutations/reset.mutation'
import { CreateAction } from './actions/create.action'
import { DeleteAction } from './actions/delete.action'
import { FindConflictingItemsAction } from './actions/find-conflicting-items'
import { ListAction } from './actions/list.action'
import { LoadToolConfigAction } from './actions/load-tool-config.action'
import { ReadAction } from './actions/read.action'
import { SetPaginationAction } from './actions/set-pagination.mutation'
import { SetSortingAction } from './actions/set-sorting.mutation'
import { UpdateAction } from './actions/update.action'
import { PaginationGetter } from './getters/pagination.getter'
import { StateGetter } from './getters/state.getter'
import { SetPaginationStateMutation } from './mutations/set-pagination-state.mutation'
import { SetStateMutation } from './mutations/set-state.mutation'
import { TOOLING_CONSTS } from './tooling.consts'

export const TOOLING_MODULE: Module<ToolingState, any> = {
  namespaced: true,

  initialState: (): ToolingState => {
    let initialItemsPerPage = 0
    const storageService = CONTAINER.get<StorageService>(TYPES.StorageService)
    const storageItemsPerPage = storageService.getItem(TOOLING_CONSTS.storage.itemsPerPage)
    if (storageItemsPerPage) {
      initialItemsPerPage = Number(storageItemsPerPage)
    }
    return {
      pagination: {
        itemsPerPage: initialItemsPerPage,
      },
      tools: {},
    }
  },
  state: (): ToolingState => TOOLING_MODULE.initialState(),

  getters: {
    [TOOLING_CONSTS.getters.state]: StateGetter.execute,
    [TOOLING_CONSTS.getters.pagination]: PaginationGetter.execute,
  },

  actions: {
    [TOOLING_CONSTS.actions.loadToolConfig]: LoadToolConfigAction.execute,

    [TOOLING_CONSTS.actions.list]: ListAction.execute,
    [TOOLING_CONSTS.actions.findConflictingItems]: FindConflictingItemsAction.execute,
    [TOOLING_CONSTS.actions.create]: CreateAction.execute,
    [TOOLING_CONSTS.actions.read]: ReadAction.execute,
    [TOOLING_CONSTS.actions.update]: UpdateAction.execute,
    [TOOLING_CONSTS.actions.delete]: DeleteAction.execute,

    [TOOLING_CONSTS.actions.setPagination]: SetPaginationAction.execute,
    [TOOLING_CONSTS.actions.setSorting]: SetSortingAction.execute,

    [COMMON_CONSTS.actions.reset]: context =>
      ResetAction.execute(context, TOOLING_MODULE.initialState()),
  },

  mutations: {
    [TOOLING_CONSTS.mutations.setState]: SetStateMutation.execute,
    [TOOLING_CONSTS.mutations.setPagination]: SetPaginationStateMutation.execute,

    [COMMON_CONSTS.mutations.reset]: ResetMutation.execute,
  },
}
